var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCanceledStatus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12 0c6.627 0 12 5.372 12 12 0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zm0 1.92C6.442 1.92 1.92 6.442 1.92 12S6.442 22.08 12 22.08 22.08 17.558 22.08 12 17.558 1.92 12 1.92zm4.56 8.88c.663 0 1.2.537 1.2 1.2 0 .663-.537 1.2-1.2 1.2H7.44c-.663 0-1.2-.537-1.2-1.2 0-.663.537-1.2 1.2-1.2z",
    transform: "translate(-1262.000000, -207.000000) translate(462.000000, 10.000000) translate(0.000000, 95.000000) translate(0.000000, 64.000000) translate(780.000000, 32.000000) translate(20.000000, 6.000000)"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanceledStatus);
export default __webpack_public_path__ + "static/media/canceled-status.6c56da78212794a46e1021b4b58a6630.svg";
export { ForwardRef as ReactComponent };